module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('div', [(_vm.isLoading) ? _c('CustomLoader', {
    attrs: {
      "width": 70
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('b-card', {
    staticClass: "mainCardBG"
  }, [_c('b-card-text', [_c('b-navbar', {
    staticClass: "formCard",
    staticStyle: {
      "border-radius": "5px !important",
      "padding-left": "0px"
    },
    attrs: {
      "toggleable": "lg",
      "type": "dark",
      "variant": "primary"
    }
  }, [_c('b-navbar-nav', [_c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "light"
    },
    on: {
      "click": _vm.previousSalesView
    }
  }, [_c('md-icon', {
    attrs: {
      "icon": "gear-fill",
      "aria-hidden": "true"
    }
  }, [_vm._v("skip_previous")]), _vm._v("Back\n          ")], 1)], 1), _vm._v(" "), _c('b-navbar-brand', {
    attrs: {
      "center": ""
    }
  }, [_vm._v("BL - US")])], 1), _vm._v(" "), _c('b-card', {
    staticClass: "formCard"
  }, [_c('b-card-text', [(_vm.getCLientData.length > 0 || _vm.BLRaised.conFclBLNonUsId != '') ? _c('div', [_c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "35"
    }
  }, [(_vm.BLRaised.conFclBLNonUsId == '') ? _c('label', {
    attrs: {
      "for": "fclConsoMultipleClientId"
    }
  }, [_vm._v("Client Name")]) : _vm._e(), _vm._v(" "), (_vm.BLRaised.conFclBLNonUsId == '') ? _c('model-list-select', {
    attrs: {
      "list": _vm.clientList,
      "id": "fclConsoMultipleClientId",
      "option-value": "fclConsoMultipleClientId",
      "option-text": "clientName",
      "placeholder": "Select  Client Name"
    },
    model: {
      value: (_vm.BLRaised.fclConsoMultipleClientId),
      callback: function($$v) {
        _vm.$set(_vm.BLRaised, "fclConsoMultipleClientId", $$v)
      },
      expression: "BLRaised.fclConsoMultipleClientId"
    }
  }) : _c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', {
    attrs: {
      "for": "clientName"
    }
  }, [_vm._v("Client Name")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "disabled": ""
    },
    model: {
      value: (_vm.BLRaised.clientName),
      callback: function($$v) {
        _vm.$set(_vm.BLRaised, "clientName", $$v)
      },
      expression: "BLRaised.clientName"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', {
    attrs: {
      "for": "blType"
    }
  }, [_vm._v("B/L Stage")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.blStageList,
      "option-value": "blStageVal",
      "option-text": "blStageTxt",
      "placeholder": "Select B/L Stage"
    },
    model: {
      value: (_vm.BLRaised.blStage),
      callback: function($$v) {
        _vm.$set(_vm.BLRaised, "blStage", $$v)
      },
      expression: "BLRaised.blStage"
    }
  }), _vm._v(" "), (!_vm.BLRaised.blStage) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorBLRaised.blStage))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticStyle: {
      "margin-top": "2%"
    },
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('label', [_vm._v("EXPORTER / SHIPPER")])]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('label', [_vm._v("CONSIGNEE ( OR ORDER)")])])], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('quill-editor', {
    ref: "consignor",
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.BLRaised.consignor),
      callback: function($$v) {
        _vm.$set(_vm.BLRaised, "consignor", $$v)
      },
      expression: "BLRaised.consignor"
    }
  })], 1), _vm._v(" "), (!_vm.BLRaised.consignor) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorBLRaised.consignor))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('quill-editor', {
    ref: "myTextEditor",
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.BLRaised.consignee),
      callback: function($$v) {
        _vm.$set(_vm.BLRaised, "consignee", $$v)
      },
      expression: "BLRaised.consignee"
    }
  })], 1), _vm._v(" "), (!_vm.BLRaised.consignee) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorBLRaised.consignee))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "gutter": ""
    }
  }, _vm._l((_vm.BLRaised.notifyList), function(singleInput, index) {
    return _c('md-layout', {
      key: index,
      staticClass: "gutr",
      attrs: {
        "md-flex": "30"
      }
    }, [_c('md-layout', {
      attrs: {
        "md-flex": "100"
      }
    }, [_c('md-layout', {
      attrs: {
        "md-flex": "15"
      }
    }), _vm._v(" "), _c('md-layout', {
      attrs: {
        "md-flex": "60"
      }
    }, [_c('label', [_vm._v(_vm._s(_vm.notifyArray[index]) + " Notify Party")])]), _vm._v(" "), (index > 1) ? _c('md-layout', {
      attrs: {
        "md-flex": "15"
      }
    }, [_c('md-button', {
      staticClass: "md-icon-button md-raised md-dense",
      staticStyle: {
        "min-height": "20px",
        "height": "20px"
      },
      on: {
        "click": function($event) {
          _vm.removeNotify(index)
        }
      }
    }, [_c('md-icon', [_vm._v("close")])], 1)], 1) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
      attrs: {
        "md-flex": "100"
      }
    }, [_c('md-layout', {
      attrs: {
        "md-flex": "15"
      }
    }), _vm._v(" "), _c('md-layout', {
      attrs: {
        "md-flex": "70"
      }
    }, [_c('quill-editor', {
      ref: "myTextEditor",
      refInFor: true,
      model: {
        value: (singleInput.inputValue),
        callback: function($$v) {
          _vm.$set(singleInput, "inputValue", $$v)
        },
        expression: "singleInput.inputValue"
      }
    })], 1)], 1)], 1)
  })), _vm._v(" "), _c('md-layout', {
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('label', {
    staticClass: "showMoreData",
    on: {
      "click": _vm.addNotify
    }
  }, [_vm._v("Add Notify")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader1"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Bill of Lading No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "billLading",
      "name": "billLading"
    },
    model: {
      value: (_vm.BLRaised.billLading),
      callback: function($$v) {
        _vm.$set(_vm.BLRaised, "billLading", $$v)
      },
      expression: "BLRaised.billLading"
    }
  })], 1), _vm._v(" "), (!_vm.BLRaised.billLading) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorBLRaised.billLading))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Booking No.")]), _vm._v(" "), _c('b-form-input', {
    ref: "bookingNo",
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "bookingNo",
      "name": "bookingNo"
    },
    model: {
      value: (_vm.BLRaised.bookingNo),
      callback: function($$v) {
        _vm.$set(_vm.BLRaised, "bookingNo", $$v)
      },
      expression: "BLRaised.bookingNo"
    }
  })], 1), _vm._v(" "), (!_vm.BLRaised.bookingNo) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorBLRaised.bookingNo))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Consolidation No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "consolidationNO",
      "name": "consolidationNO"
    },
    model: {
      value: (_vm.BLRaised.consolidationNO),
      callback: function($$v) {
        _vm.$set(_vm.BLRaised, "consolidationNO", $$v)
      },
      expression: "BLRaised.consolidationNO"
    }
  })], 1), _vm._v(" "), (!_vm.BLRaised.consolidationNO) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorBLRaised.consolidationNO))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("SCAC")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "SCAC",
      "name": "SCAC"
    },
    model: {
      value: (_vm.BLRaised.SCAC),
      callback: function($$v) {
        _vm.$set(_vm.BLRaised, "SCAC", $$v)
      },
      expression: "BLRaised.SCAC"
    }
  })], 1), _vm._v(" "), (!_vm.BLRaised.SCAC) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorBLRaised.SCAC))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Type of Move")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "typeMove",
      "name": "typeMove"
    },
    model: {
      value: (_vm.BLRaised.typeMove),
      callback: function($$v) {
        _vm.$set(_vm.BLRaised, "typeMove", $$v)
      },
      expression: "BLRaised.typeMove"
    }
  })], 1), _vm._v(" "), (!_vm.BLRaised.typeMove) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorBLRaised.typeMove))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Export References")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "exportReference",
      "name": "exportReference"
    },
    model: {
      value: (_vm.BLRaised.exportReference),
      callback: function($$v) {
        _vm.$set(_vm.BLRaised, "exportReference", $$v)
      },
      expression: "BLRaised.exportReference"
    }
  })], 1), _vm._v(" "), (!_vm.BLRaised.exportReference) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorBLRaised.exportReference))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Shipper References")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "shippingReferenceNum",
      "name": "shippingReferenceNum"
    },
    model: {
      value: (_vm.BLRaised.shippingReferenceNum),
      callback: function($$v) {
        _vm.$set(_vm.BLRaised, "shippingReferenceNum", $$v)
      },
      expression: "BLRaised.shippingReferenceNum"
    }
  })], 1), _vm._v(" "), (!_vm.BLRaised.shippingReferenceNum) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorBLRaised.shippingReferenceNum))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', {
    attrs: {
      "for": "blType"
    }
  }, [_vm._v("Forwarding Agent")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.AgentList,
      "option-value": "agntColoaderId",
      "option-text": "agentName",
      "placeholder": "Select Delievery Agent"
    },
    model: {
      value: (_vm.BLRaised.forwardingAgent),
      callback: function($$v) {
        _vm.$set(_vm.BLRaised, "forwardingAgent", $$v)
      },
      expression: "BLRaised.forwardingAgent"
    }
  }), _vm._v(" "), (!_vm.BLRaised.forwardingAgent) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorBLRaised.forwardingAgent))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Pre­Carriage By")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "",
      "name": ""
    },
    model: {
      value: (_vm.BLRaised.preCarriage),
      callback: function($$v) {
        _vm.$set(_vm.BLRaised, "preCarriage", $$v)
      },
      expression: "BLRaised.preCarriage"
    }
  })], 1), _vm._v(" "), (!_vm.BLRaised.preCarriage) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorBLRaised.preCarriage))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', {
    attrs: {
      "for": "blType"
    }
  }, [_vm._v("Delievery Agent")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.AgentList,
      "option-value": "agntColoaderId",
      "option-text": "agentName",
      "placeholder": "Select Delievery Agent"
    },
    model: {
      value: (_vm.BLRaised.delieveryAgent),
      callback: function($$v) {
        _vm.$set(_vm.BLRaised, "delieveryAgent", $$v)
      },
      expression: "BLRaised.delieveryAgent"
    }
  }), _vm._v(" "), (!_vm.BLRaised.delieveryAgent) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorBLRaised.delieveryAgent))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Point of Origin/FTZ No.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "pointofOrigin",
      "name": "pointofOrigin"
    },
    model: {
      value: (_vm.BLRaised.pointofOrigin),
      callback: function($$v) {
        _vm.$set(_vm.BLRaised, "pointofOrigin", $$v)
      },
      expression: "BLRaised.pointofOrigin"
    }
  })], 1), _vm._v(" "), (!_vm.BLRaised.pointofOrigin) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorBLRaised.pointofOrigin))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Place of Receipt By Pre-Carrier")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "placeReceipt",
      "name": "placeReceipt"
    },
    model: {
      value: (_vm.BLRaised.placeReceipt),
      callback: function($$v) {
        _vm.$set(_vm.BLRaised, "placeReceipt", $$v)
      },
      expression: "BLRaised.placeReceipt"
    }
  })], 1), _vm._v(" "), (!_vm.BLRaised.placeReceipt) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorBLRaised.placeReceipt))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Loading Peer / Terminal")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "loadingPreTerminal",
      "name": "loadingPreTerminal"
    },
    model: {
      value: (_vm.BLRaised.loadingPreTerminal),
      callback: function($$v) {
        _vm.$set(_vm.BLRaised, "loadingPreTerminal", $$v)
      },
      expression: "BLRaised.loadingPreTerminal"
    }
  })], 1), _vm._v(" "), (!_vm.BLRaised.loadingPreTerminal) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorBLRaised.loadingPreTerminal))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Vessel/Voy")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "vesselVoy",
      "name": "vesselVoy"
    },
    model: {
      value: (_vm.BLRaised.vesselVoy),
      callback: function($$v) {
        _vm.$set(_vm.BLRaised, "vesselVoy", $$v)
      },
      expression: "BLRaised.vesselVoy"
    }
  })], 1), _vm._v(" "), (!_vm.BLRaised.vesselVoy) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorBLRaised.vesselVoy))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Port of Loading")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "portLoad",
      "name": "portLoad"
    },
    model: {
      value: (_vm.BLRaised.portLoad),
      callback: function($$v) {
        _vm.$set(_vm.BLRaised, "portLoad", $$v)
      },
      expression: "BLRaised.portLoad"
    }
  })], 1), _vm._v(" "), (!_vm.BLRaised.portLoad) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorBLRaised.portLoad))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Port of Discharge")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "portDischarge",
      "name": "portDischarge"
    },
    model: {
      value: (_vm.BLRaised.portDischarge),
      callback: function($$v) {
        _vm.$set(_vm.BLRaised, "portDischarge", $$v)
      },
      expression: "BLRaised.portDischarge"
    }
  })], 1), _vm._v(" "), (!_vm.BLRaised.portDischarge) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorBLRaised.portDischarge))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Place of Delivery")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "placeDilievery",
      "name": "placeDilievery"
    },
    model: {
      value: (_vm.BLRaised.placeDilievery),
      callback: function($$v) {
        _vm.$set(_vm.BLRaised, "placeDilievery", $$v)
      },
      expression: "BLRaised.placeDilievery"
    }
  })], 1), _vm._v(" "), (!_vm.BLRaised.placeDilievery) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorBLRaised.placeDilievery))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "gutr",
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "90"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Refrences")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "reference",
      "name": "reference"
    },
    model: {
      value: (_vm.BLRaised.reference),
      callback: function($$v) {
        _vm.$set(_vm.BLRaised, "reference", $$v)
      },
      expression: "BLRaised.reference"
    }
  })], 1), _vm._v(" "), (!_vm.BLRaised.reference) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorBLRaised.reference))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('hr'), _vm._v(" "), _c('md-layout', {
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "80"
    }
  }, [_c('label', [_vm._v("Description of Packages and Goods")])])], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "80"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('quill-editor', {
    ref: "myTextEditor",
    staticStyle: {
      "width": "900px !important"
    },
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.BLRaised.descriptionGood),
      callback: function($$v) {
        _vm.$set(_vm.BLRaised, "descriptionGood", $$v)
      },
      expression: "BLRaised.descriptionGood"
    }
  })], 1), _vm._v(" "), (!_vm.BLRaised.descriptionGood) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorBLRaised.descriptionGood))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticStyle: {
      "margin-top": "2%"
    },
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('label', [_vm._v("Description of Charges")])]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('label', [_vm._v("Prepaid")])]), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('label', [_vm._v("Collect")])])], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('quill-editor', {
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.BLRaised.desCharges),
      callback: function($$v) {
        _vm.$set(_vm.BLRaised, "desCharges", $$v)
      },
      expression: "BLRaised.desCharges"
    }
  })], 1)], 1), _vm._v(" "), (!_vm.BLRaised.desCharges) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorBLRaised.desCharges))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('quill-editor', {
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.BLRaised.prepaid),
      callback: function($$v) {
        _vm.$set(_vm.BLRaised, "prepaid", $$v)
      },
      expression: "BLRaised.prepaid"
    }
  })], 1), _vm._v(" "), (!_vm.BLRaised.prepaid) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorBLRaised.prepaid))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('quill-editor', {
    attrs: {
      "options": _vm.editorOption
    },
    model: {
      value: (_vm.BLRaised.collect),
      callback: function($$v) {
        _vm.$set(_vm.BLRaised, "collect", $$v)
      },
      expression: "BLRaised.collect"
    }
  })], 1), _vm._v(" "), (!_vm.BLRaised.collect) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorBLRaised.collect))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "labelMargtop",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('label', {
    attrs: {
      "for": "blType"
    }
  }, [_vm._v("Place")]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.PlaceList,
      "option-value": "PlaceVal",
      "option-text": "PlaceTxt",
      "placeholder": "Select Pridel Branch Name"
    },
    model: {
      value: (_vm.BLRaised.placeBranch),
      callback: function($$v) {
        _vm.$set(_vm.BLRaised, "placeBranch", $$v)
      },
      expression: "BLRaised.placeBranch"
    }
  }), _vm._v(" "), (!_vm.BLRaised.placeBranch) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorBLRaised.placeBranch))]) : _vm._e()], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "100"
    }
  }, [_c('label', [_vm._v("Total")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "id": "total",
      "name": "total"
    },
    model: {
      value: (_vm.BLRaised.total),
      callback: function($$v) {
        _vm.$set(_vm.BLRaised, "total", $$v)
      },
      expression: "BLRaised.total"
    }
  })], 1), _vm._v(" "), (!_vm.BLRaised.total) ? _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorBLRaised.total))]) : _vm._e()], 1)], 1), _vm._v(" "), _c('hr', {
    staticClass: "hr-s"
  }), _vm._v(" "), _c('md-layout', {
    staticClass: "mrgtop-2per",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "45"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "primary",
      "id": "addButtonLoader"
    },
    on: {
      "click": _vm.addBLRaised
    }
  }, [_vm._v("Submit")]), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader"
    }
  })], 1)], 1), _vm._v(" "), _c('hr', {
    staticClass: "hr-s"
  }), _vm._v(" "), (_vm.containerDetail.length > 0) ? _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('label', {
    staticClass: "box-title"
  }, [_vm._v("Container Detail(US)")])]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-bordered",
    attrs: {
      "id": "clientSB"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.selectAllContainers),
      expression: "selectAllContainers"
    }],
    attrs: {
      "type": "checkbox",
      "indeterminate": _vm.isIndeterminate
    },
    domProps: {
      "checked": Array.isArray(_vm.selectAllContainers) ? _vm._i(_vm.selectAllContainers, null) > -1 : (_vm.selectAllContainers)
    },
    on: {
      "change": [function($event) {
        var $$a = _vm.selectAllContainers,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.selectAllContainers = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.selectAllContainers = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.selectAllContainers = $$c
        }
      }, _vm.toggleSelectAll]
    }
  })]), _vm._v(" "), _c('th', [_vm._v("Container No")]), _vm._v(" "), _c('th', [_vm._v("Container Type")]), _vm._v(" "), _c('th', [_vm._v("Seal No")]), _vm._v(" "), _c('th', [_vm._v("Gross Weight")]), _vm._v(" "), _c('th', [_vm._v("Measurement")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.containerDetail), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (item.selected),
        expression: "item.selected"
      }],
      attrs: {
        "type": "checkbox",
        "disabled": item.containerWithSplit == 1
      },
      domProps: {
        "checked": Array.isArray(item.selected) ? _vm._i(item.selected, null) > -1 : (item.selected)
      },
      on: {
        "change": [function($event) {
          var $$a = item.selected,
            $$el = $event.target,
            $$c = $$el.checked ? (true) : (false);
          if (Array.isArray($$a)) {
            var $$v = null,
              $$i = _vm._i($$a, $$v);
            if ($$el.checked) {
              $$i < 0 && (item.selected = $$a.concat([$$v]))
            } else {
              $$i > -1 && (item.selected = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
            }
          } else {
            _vm.$set(item, "selected", $$c)
          }
        }, _vm.updateSelectAll]
      }
    })]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.fclConcontainerNo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.containerType))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.customSealNo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.conGrossWeight))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.measurement))])])
  }))])]), _vm._v(" "), (_vm.containerDetail.length > 0) ? _c('div', {
    staticClass: "mt-3"
  }, [_c('div', {
    staticClass: "alert alert-info"
  }, [_c('strong', [_vm._v("Container Selection:")]), _vm._v(" Use the checkboxes to select individual containers or use the controls below for bulk operations. \n                  Selected containers can be used for specific operations. Containers with split status are disabled.\n                ")]), _vm._v(" "), (!_vm.hasSelectedContainers) ? _c('div', {
    staticClass: "alert alert-warning"
  }, [_c('strong', [_vm._v("Warning:")]), _vm._v(" Please select at least one container to proceed.\n                ")]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('b-button', {
    staticClass: "mr-2",
    attrs: {
      "size": "sm",
      "variant": "info"
    },
    on: {
      "click": function($event) {
        _vm.selectAllContainers = true;
        _vm.toggleSelectAll()
      }
    }
  }, [_vm._v("\n                      Select All\n                    ")]), _vm._v(" "), _c('b-button', {
    staticClass: "mr-2",
    attrs: {
      "size": "sm",
      "variant": "secondary"
    },
    on: {
      "click": function($event) {
        _vm.selectAllContainers = false;
        _vm.toggleSelectAll()
      }
    }
  }, [_vm._v("\n                      Deselect All\n                    ")])], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-6 text-right"
  }, [_c('span', {
    staticClass: "text-muted"
  }, [_vm._v("\n                      Selected: " + _vm._s(_vm.selectedContainersCount) + " of " + _vm._s(_vm.selectableContainersCount) + " containers\n                    ")])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('hr', {
    staticClass: "hr-s"
  })], 1) : _vm._e(), _vm._v(" "), _c('hr', {
    staticClass: "hr-s"
  }), _vm._v(" "), (_vm.nonUsBlTable.length > 0) ? _c('div', {
    staticClass: "box"
  }, [_c('div', {
    staticClass: "box-header"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Client BL Details(US)")]), _vm._v(" "), _c('b-button', {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.openNoteModal(2)
      }
    }
  }, [_vm._v("Debit Note")]), _vm._v(" "), _c('b-button', {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.openNoteModal(1)
      }
    }
  }, [_vm._v("Credit Note")]), _vm._v(" "), _c('b-button', {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": _vm.openPreAlert
    }
  }, [_vm._v("Pre Alert Mail")]), _vm._v(" "), _c('Filter-Agency-Modal'), _vm._v(" "), _c('FilterCBModal'), _vm._v(" "), _c('ClientCard'), _vm._v(" "), _c('ShipmentTrackCard')], 1), _vm._v(" "), _c('hr', {
    staticClass: "hr-s"
  }), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('table', {
    staticClass: "table table-bordered table-striped",
    attrs: {
      "id": "clientSB"
    }
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Sr No.")]), _vm._v(" "), _c('th', [_vm._v("Client Name")]), _vm._v(" "), _c('th', [_vm._v("BL Stage")]), _vm._v(" "), _c('th', [_vm._v("Print")]), _vm._v(" "), _c('th', [_vm._v("Download Word")])])]), _vm._v(" "), _c('tbody', _vm._l((_vm.nonUsBlTable), function(item, index) {
    return _c('tr', {
      key: index
    }, [_c('td', [_vm._v(_vm._s(index + 1))]), _vm._v(" "), _c('td', {
      staticClass: "showMoreData",
      on: {
        "click": function($event) {
          _vm.viewEditBLNonUs(item)
        }
      }
    }, [_vm._v(_vm._s(item.clientName))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(item.blStage))]), _vm._v(" "), _c('td', [_c('md-button', {
      staticClass: "md-icon-button md-raised md-dense",
      on: {
        "click": function($event) {
          _vm.Print(item.uploadBLCon)
        }
      }
    }, [_c('md-icon', [_vm._v("print")])], 1)], 1), _vm._v(" "), _c('td', [_c('md-button', {
      staticClass: "md-icon-button md-raised md-dense",
      on: {
        "click": function($event) {
          _vm.downloadWord(item.conFclBLNonUsId)
        }
      }
    }, [_c('md-icon', [_vm._v("cloud_download")])], 1)], 1)])
  }))])])]) : _vm._e(), _vm._v(" "), (_vm.BLRaised.conFclBLNonUsId == '' && _vm.getCLientData.length == 0) ? _c('hr', {
    staticClass: "hr-s"
  }) : _vm._e(), _vm._v(" "), (_vm.getCLientData.length == 0 && _vm.BLRaised.conFclBLNonUsId == '') ? _c('md-layout', {
    staticClass: "mrgtop-2per",
    attrs: {
      "md-gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "40"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "20"
    }
  }, [_c('md-button', {
    staticClass: "md-raised md-primary md-button-color heght-1px",
    attrs: {
      "id": "addButtonLoader"
    },
    on: {
      "click": _vm.proceedAws
    }
  }, [_vm._v("Proceed to AMS Filling")]), _vm._v(" "), _c('b-modal', {
    ref: "note-modal",
    attrs: {
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "size": "xl",
      "hide-footer": "",
      "title": ""
    }
  }, [_c('div', {
    staticClass: "d-block text-center"
  }, [_c('h3', [_vm._v(_vm._s(_vm.noteModal.creditDebitNoteType == '1' ? 'CREDIT NOTE' : 'DEBIT NOTE'))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h4', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.noteModal.approvalStatus == '1' ? 'Approved' : _vm.noteModal.sentForApproval == '1' ? 'Sent for approval' : ''))])]), _vm._v(" "), (_vm.noteModal.uploadCreditDebit != '' && _vm.noteModal.approvalStatus == '1') ? _c('b-button', {
    attrs: {
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": function($event) {
        _vm.PrintNote(_vm.noteModal.uploadCreditDebit)
      }
    }
  }, [_vm._v("PDF")]) : _vm._e(), _vm._v(" "), _c('b-button', {
    attrs: {
      "size": "sm"
    },
    on: {
      "click": _vm.addContent
    }
  }, [_vm._v("\n                  Add Particulars\n                  "), _c('i', {
    staticClass: "fa fa-plus-circle ml-1"
  })]), _vm._v(" "), _c('b-row', [_c('b-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('label', [_vm._v("Date")]), _vm._v(" "), _c('date-picker', {
    attrs: {
      "format": _vm.selectDateFormat,
      "lang": "en",
      "id": "blDate",
      "name": "blDate"
    },
    model: {
      value: (_vm.noteModal.noteDate),
      callback: function($$v) {
        _vm.$set(_vm.noteModal, "noteDate", $$v)
      },
      expression: "noteModal.noteDate"
    }
  })], 1)], 1), _vm._v(" "), _vm._l((_vm.noteParticulars), function(item, index) {
    return _c('div', {
      key: index,
      staticClass: "mt-4"
    }, [_c('b-row', [_c('b-col', {
      attrs: {
        "cols": "8"
      }
    }, [_c('label', {
      attrs: {
        "for": "jj"
      }
    }, [_vm._v("Particular")]), _vm._v(" "), _c('b-form-input', {
      attrs: {
        "formatter": _vm.capitalizeAll,
        "placeholder": "Enter Particular"
      },
      model: {
        value: (item.parti),
        callback: function($$v) {
          _vm.$set(item, "parti", $$v)
        },
        expression: "item.parti"
      }
    })], 1), _vm._v(" "), _c('b-col', {
      attrs: {
        "cols": "2"
      }
    }, [_c('label', {
      attrs: {
        "for": "jju"
      }
    }, [_vm._v("Amount")]), _vm._v(" "), _c('b-form-input', {
      attrs: {
        "formatter": _vm.capitalizeAll,
        "type": "number",
        "placeholder": "Enter Amount"
      },
      model: {
        value: (item.amt),
        callback: function($$v) {
          _vm.$set(item, "amt", $$v)
        },
        expression: "item.amt"
      }
    })], 1), _vm._v(" "), (index > 0) ? _c('b-button', {
      staticClass: "pull-right",
      staticStyle: {
        "margin-top": "38px"
      },
      attrs: {
        "size": "sm"
      },
      on: {
        "click": function($event) {
          _vm.removeParti(index)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-minus-circle",
      attrs: {
        "aria-hidden": "true"
      }
    })]) : _vm._e()], 1)], 1)
  }), _vm._v(" "), _c('b-row', {
    staticClass: "mt-2"
  }, [_c('b-col', [_c('label', {
    attrs: {
      "for": "jj"
    }
  }, [_vm._v("Remarks")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll
    },
    model: {
      value: (_vm.noteModal.remarks),
      callback: function($$v) {
        _vm.$set(_vm.noteModal, "remarks", $$v)
      },
      expression: "noteModal.remarks"
    }
  })], 1)], 1), _vm._v(" "), (_vm.noteParticulars.length > 0 && _vm.ShowSendApproval == true) ? _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "success",
      "block": ""
    },
    on: {
      "click": _vm.submitNote
    }
  }, [_vm._v("Send for approval")]) : _vm._e(), _vm._v(" "), _c('b-button', {
    staticClass: "mt-5",
    attrs: {
      "variant": "outline-danger",
      "block": ""
    },
    on: {
      "click": _vm.hideNoteModal
    }
  }, [_vm._v("Close")])], 2), _vm._v(" "), _c('b-modal', {
    ref: "pre-alert-modal",
    attrs: {
      "no-close-on-esc": "",
      "no-close-on-backdrop": "",
      "size": "xl",
      "hide-footer": "",
      "title": ""
    }
  }, [_c('b-row', {
    staticClass: "mt-2"
  }, [_c('b-col', {
    attrs: {
      "cols": "9"
    }
  }, [_c('div', {
    staticClass: "d-block text-center"
  }, [_c('h3', [_vm._v("FCL Export BL Pre Alert")]), _vm._v(" "), _c('br')])]), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "3"
    }
  }, [(_vm.preAlertData.fclConAlertId != '' && _vm.allData[0].billingType != '1') ? _c('b-button', {
    staticStyle: {
      "margin-left": "5px"
    },
    attrs: {
      "size": "sm",
      "variant": "warning"
    },
    on: {
      "click": _vm.sendMANIFESTATION
    }
  }, [_vm._v("SEND MANIFESTATION DETAILS")]) : _vm._e()], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mt-2"
  }, [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "jj"
    }
  }, [_vm._v("AGENT REFERENCE ID")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "VESSEL & VOY"
    },
    model: {
      value: (_vm.preAlertData.agent_reference_id),
      callback: function($$v) {
        _vm.$set(_vm.preAlertData, "agent_reference_id", $$v)
      },
      expression: "preAlertData.agent_reference_id"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('label', {
    attrs: {
      "for": "jj"
    }
  }, [_vm._v("SHIPPING LINE")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "SHIPPING LINE"
    },
    model: {
      value: (_vm.preAlertData.shippingLine),
      callback: function($$v) {
        _vm.$set(_vm.preAlertData, "shippingLine", $$v)
      },
      expression: "preAlertData.shippingLine"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('label', {
    attrs: {
      "for": "jj"
    }
  }, [_vm._v("SHIPMENT TYPE")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "SHIPMENT TYPE"
    },
    model: {
      value: (_vm.preAlertData.shipmentType),
      callback: function($$v) {
        _vm.$set(_vm.preAlertData, "shipmentType", $$v)
      },
      expression: "preAlertData.shipmentType"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mt-2"
  }, [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('label', {
    attrs: {
      "for": "jj"
    }
  }, [_vm._v("SHIPPER NAME")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "SHIPPER NAME"
    },
    model: {
      value: (_vm.preAlertData.shipper_name),
      callback: function($$v) {
        _vm.$set(_vm.preAlertData, "shipper_name", $$v)
      },
      expression: "preAlertData.shipper_name"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('label', {
    attrs: {
      "for": "jj"
    }
  }, [_vm._v("CONSIGNEE")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll
    },
    model: {
      value: (_vm.preAlertData.consignee),
      callback: function($$v) {
        _vm.$set(_vm.preAlertData, "consignee", $$v)
      },
      expression: "preAlertData.consignee"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mt-2"
  }, [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('label', {
    attrs: {
      "for": "jj"
    }
  }, [_vm._v("OVERSEAS AGENT")]), _vm._v(" "), _c('b-form-textarea', {
    attrs: {
      "formatter": _vm.capitalizeAll
    },
    model: {
      value: (_vm.preAlertData.delieveryAgent),
      callback: function($$v) {
        _vm.$set(_vm.preAlertData, "delieveryAgent", $$v)
      },
      expression: "preAlertData.delieveryAgent"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('label', {
    attrs: {
      "for": "jj"
    }
  }, [_vm._v("LOAD PORT")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "LOAD PORT"
    },
    model: {
      value: (_vm.preAlertData.portLoad),
      callback: function($$v) {
        _vm.$set(_vm.preAlertData, "portLoad", $$v)
      },
      expression: "preAlertData.portLoad"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mt-2"
  }, [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('label', {
    attrs: {
      "for": "jj"
    }
  }, [_vm._v("PLACE OF DELIVERY")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "PLACE OF DELIVERY"
    },
    model: {
      value: (_vm.preAlertData.placeDilievery),
      callback: function($$v) {
        _vm.$set(_vm.preAlertData, "placeDilievery", $$v)
      },
      expression: "preAlertData.placeDilievery"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('label', {
    attrs: {
      "for": "jj"
    }
  }, [_vm._v("CONTAINER NO.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "CONTAINER NO."
    },
    model: {
      value: (_vm.preAlertData.container_no),
      callback: function($$v) {
        _vm.$set(_vm.preAlertData, "container_no", $$v)
      },
      expression: "preAlertData.container_no"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mt-2"
  }, [_c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "jj"
    }
  }, [_vm._v("HOUSE BL NO.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "HOUSE BL NO."
    },
    model: {
      value: (_vm.preAlertData.house_bl_no),
      callback: function($$v) {
        _vm.$set(_vm.preAlertData, "house_bl_no", $$v)
      },
      expression: "preAlertData.house_bl_no"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "jj"
    }
  }, [_vm._v("MASTER BL NO.")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "MASTER BL NO."
    },
    model: {
      value: (_vm.preAlertData.master_bl_no),
      callback: function($$v) {
        _vm.$set(_vm.preAlertData, "master_bl_no", $$v)
      },
      expression: "preAlertData.master_bl_no"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "4"
    }
  }, [_c('label', {
    attrs: {
      "for": "jj"
    }
  }, [_vm._v("VESSEL & VOY")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "VESSEL & VOY"
    },
    model: {
      value: (_vm.preAlertData.vesselVoy),
      callback: function($$v) {
        _vm.$set(_vm.preAlertData, "vesselVoy", $$v)
      },
      expression: "preAlertData.vesselVoy"
    }
  })], 1)], 1), _vm._v(" "), _c('b-row', {
    staticClass: "mt-2"
  }, [_c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('label', {
    attrs: {
      "for": "jj"
    }
  }, [_vm._v("ETD / SOB DATE")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "ETD / SOB DATE"
    },
    model: {
      value: (_vm.preAlertData.etd_date),
      callback: function($$v) {
        _vm.$set(_vm.preAlertData, "etd_date", $$v)
      },
      expression: "preAlertData.etd_date"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('label', {
    attrs: {
      "for": "jj"
    }
  }, [_vm._v("ETA DISCHARGE")]), _vm._v(" "), _c('b-form-input', {
    attrs: {
      "formatter": _vm.capitalizeAll,
      "placeholder": "ETA DISCHARGE"
    },
    model: {
      value: (_vm.preAlertData.eta_date),
      callback: function($$v) {
        _vm.$set(_vm.preAlertData, "eta_date", $$v)
      },
      expression: "preAlertData.eta_date"
    }
  })], 1), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('label', {
    attrs: {
      "for": "deliveryTerms"
    }
  }, [_vm._v("Delivery Terms(INCOTERMS)"), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.deliveryTermsName,
      "option-value": "deliveryTermsVal",
      "option-text": "deliveryTermsText",
      "placeholder": "Select Delivery Terms"
    },
    model: {
      value: (_vm.preAlertData.deliverytermmode),
      callback: function($$v) {
        _vm.$set(_vm.preAlertData, "deliverytermmode", $$v)
      },
      expression: "preAlertData.deliverytermmode"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCustomValidation.deliverytermmode))])], 1), _vm._v(" "), (_vm.preAlertData.deliverytermmode == 'ExWorks' || _vm.preAlertData.deliverytermmode == 'DAP' || _vm.preAlertData.deliverytermmode == 'DDP' || _vm.preAlertData.deliverytermmode == 'FCA' || _vm.preAlertData.deliverytermmode == 'FOB' || _vm.preAlertData.deliverytermmode == 'CIF' || _vm.preAlertData.deliverytermmode == 'CFR') ? _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('label', {
    attrs: {
      "for": "blType"
    }
  }, [_vm._v("Handling Agent"), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['commonDropdownMaster/getAllAgentDDList'],
      "option-value": "value",
      "option-text": "text",
      "placeholder": "Select Handling Agent"
    },
    on: {
      "input": function($event) {
        _vm.getAgentDeatils(_vm.preAlertData.handling_agent, 'handling_agent')
      }
    },
    model: {
      value: (_vm.preAlertData.handling_agent),
      callback: function($$v) {
        _vm.$set(_vm.preAlertData, "handling_agent", $$v)
      },
      expression: "preAlertData.handling_agent"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCustomValidation.handling_agent))])], 1) : _vm._e(), _vm._v(" "), (_vm.preAlertData.deliverytermmode == 'ExWorks' || _vm.preAlertData.deliverytermmode == 'DAP' || _vm.preAlertData.deliverytermmode == 'DDP' || _vm.preAlertData.deliverytermmode == 'FCA') ? _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('label', {
    attrs: {
      "for": "blType"
    }
  }, [_vm._v("Clearing Agent"), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['commonDropdownMaster/getAllAgentDDList'],
      "option-value": "value",
      "option-text": "text",
      "placeholder": "Select Clearing Agent"
    },
    on: {
      "input": function($event) {
        _vm.getAgentDeatils(_vm.preAlertData.clearing_agent, 'clearing_agent')
      }
    },
    model: {
      value: (_vm.preAlertData.clearing_agent),
      callback: function($$v) {
        _vm.$set(_vm.preAlertData, "clearing_agent", $$v)
      },
      expression: "preAlertData.clearing_agent"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCustomValidation.clearing_agent))])], 1) : _vm._e(), _vm._v(" "), (_vm.preAlertData.deliverytermmode == 'ExWorks' || _vm.preAlertData.deliverytermmode == 'DAP' || _vm.preAlertData.deliverytermmode == 'DDP' || _vm.preAlertData.deliverytermmode == 'FCA') ? _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('label', {
    attrs: {
      "for": "blType"
    }
  }, [_vm._v("Delivery Agent"), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.invCategoryList,
      "option-value": "payVal",
      "option-text": "payText",
      "placeholder": "Select Delivery Agent"
    },
    on: {
      "input": function($event) {
        _vm.getAgentDeatils(_vm.preAlertData.delivery_agent, 'delivery_agent')
      }
    },
    model: {
      value: (_vm.preAlertData.delivery_agent),
      callback: function($$v) {
        _vm.$set(_vm.preAlertData, "delivery_agent", $$v)
      },
      expression: "preAlertData.delivery_agent"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCustomValidation.delivery_agent))])], 1) : _vm._e(), _vm._v(" "), (_vm.preAlertData.delivery_agent == 'Agent') ? _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('label', {
    attrs: {
      "for": "blType"
    }
  }, [_vm._v("Agent"), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['commonDropdownMaster/getAllAgentDDList'],
      "option-value": "value",
      "option-text": "text",
      "placeholder": "Select Agent"
    },
    on: {
      "input": function($event) {
        _vm.getAgentDeatils(_vm.preAlertData.agent_type_agent, 'agent_type_agent')
      }
    },
    model: {
      value: (_vm.preAlertData.agent_type_agent),
      callback: function($$v) {
        _vm.$set(_vm.preAlertData, "agent_type_agent", $$v)
      },
      expression: "preAlertData.agent_type_agent"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCustomValidation.agent_type_agent))])], 1) : _vm._e(), _vm._v(" "), (_vm.preAlertData.delivery_agent == 'Shipping Line') ? _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('label', {
    attrs: {
      "for": "blType"
    }
  }, [_vm._v("Shipping Line"), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.$store.getters['common/getAllShippingLineList'],
      "option-value": "shippingId",
      "option-text": "shippingLine",
      "placeholder": "Select Shipping Line"
    },
    on: {
      "input": function($event) {
        _vm.getAgentDeatils(_vm.preAlertData.agent_type_sline, 'agent_type_sline')
      }
    },
    model: {
      value: (_vm.preAlertData.agent_type_sline),
      callback: function($$v) {
        _vm.$set(_vm.preAlertData, "agent_type_sline", $$v)
      },
      expression: "preAlertData.agent_type_sline"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCustomValidation.agent_type_sline))])], 1) : _vm._e(), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "6"
    }
  }, [_c('label', {
    attrs: {
      "for": "frghtTermsHbl"
    }
  }, [_vm._v("Shipping Line Charges"), _c('span', {
    staticClass: "error"
  }, [_vm._v("*")])]), _vm._v(" "), _c('model-list-select', {
    attrs: {
      "list": _vm.frghtTermsHblListName,
      "option-value": "frghtTermsHblVal",
      "option-text": "frghtTermsHblTxt",
      "placeholder": "Select Shipping Line Charges"
    },
    model: {
      value: (_vm.preAlertData.sline_charges),
      callback: function($$v) {
        _vm.$set(_vm.preAlertData, "sline_charges", $$v)
      },
      expression: "preAlertData.sline_charges"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "error"
  }, [_vm._v(_vm._s(_vm.errorCustomValidation.sline_charges))])], 1)], 1), _vm._v(" "), _c('md-layout', {
    staticClass: "my-4",
    attrs: {
      "gutter": ""
    }
  }, [_c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "30"
    }
  }, [_c('md-input-container', [_c('label', [_vm._v("Upload Master BL")]), _vm._v(" "), _c('md-file', {
    attrs: {
      "placeholder": "Click to Upload Master BL",
      "name": "masterUpload",
      "id": "masterUpload",
      "multiple": ""
    },
    on: {
      "selected": function($event) {
        _vm.onFileChangeBlDraft('masterBl')
      }
    },
    model: {
      value: (_vm.preAlertData.masterBlUpload),
      callback: function($$v) {
        _vm.$set(_vm.preAlertData, "masterBlUpload", $$v)
      },
      expression: "preAlertData.masterBlUpload"
    }
  })], 1)], 1), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "5"
    }
  }), _vm._v(" "), _c('md-layout', {
    attrs: {
      "md-flex": "25"
    }
  }, [_c('md-input-container', [_c('label', [_vm._v("Upload House BL")]), _vm._v(" "), _c('md-file', {
    attrs: {
      "placeholder": "Click to Upload House Bl",
      "name": "houseUpload",
      "id": "houseUpload",
      "multiple": ""
    },
    on: {
      "selected": function($event) {
        _vm.onFileChangeBlDraft('houseBl')
      }
    },
    model: {
      value: (_vm.preAlertData.houseBlUpload),
      callback: function($$v) {
        _vm.$set(_vm.preAlertData, "houseBlUpload", $$v)
      },
      expression: "preAlertData.houseBlUpload"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('b-button', {
    staticClass: "mt-3",
    attrs: {
      "variant": "success",
      "block": ""
    },
    on: {
      "click": _vm.submitPreAlert
    }
  }, [_vm._v("Send Pre request")]), _vm._v(" "), _c('b-button', {
    staticClass: "mt-5",
    attrs: {
      "variant": "outline-danger",
      "block": ""
    },
    on: {
      "click": _vm.hidePreAlert
    }
  }, [_vm._v("Close")])], 1), _vm._v(" "), _c('md-spinner', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "md-indeterminate": "",
      "id": "loader"
    }
  })], 1)], 1) : _vm._e()], 1)], 1)], 1)], 1), _vm._v(" "), _c('md-dialog-alert', {
    ref: "addPop",
    attrs: {
      "md-content": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  }), _vm._v(" "), _c('md-dialog-confirm', {
    ref: "addPop6",
    attrs: {
      "md-content-html": _vm.alert.content,
      "md-ok-text": _vm.alert.ok
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-fbe3c826","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/component/ffExportCon/conBLNewUs.vue
// module id = 2920
// module chunks = 0